var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDietChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "diet-chart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eff3f5",
    d: "M51.62 11.92v49.51A2.57 2.57 0 0 1 49.05 64H4a2.57 2.57 0 0 1-2.57-2.57V2.57A2.57 2.57 0 0 1 4 0h35.69l11.93 11.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M51.62 11.92v.01h-9.36a2.57 2.57 0 0 1-2.57-2.57V0l11.93 11.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d4d6",
    d: "M9.25 51.92H43.8v2.69H9.25zM9.25 43.41H43.8v2.69H9.25zM9.25 34.91H43.8v2.69H9.25zM9.25 26.4H43.8v2.69H9.25zM9.25 17.9H43.8v2.69H9.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#687d87",
    d: "M9.25 9.39h23.49v2.69H9.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3333f",
    d: "M49.91 40.75c-8.12-2.82-12.5 1.89-12.65 8.87-.13 6.03 4.9 15.8 11.23 14.2a5.73 5.73 0 0 1 2.85 0c6.33 1.6 11.36-8.18 11.23-14.2-.16-6.99-4.54-11.69-12.66-8.87z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba2537",
    d: "M49.91 40.75c-8.12-2.82-12.5 1.89-12.65 8.87-.13 6.03 4.9 15.8 11.23 14.2a5.73 5.73 0 0 1 2.85 0c6.33 1.6 11.36-8.18 11.23-14.2-.16-6.99-4.54-11.69-12.66-8.87z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3333f",
    d: "M47.62 41.56c1.35.54 2.84.45 4.19-.07 4.27-1.64 9.54 1.3 9.54 6.81 0 6.91-6.92 15.2-14.87 13.77-6.75-1.38-9.18-8.7-8.55-14.62.47-2.79 1.34-4.54 3.01-5.83 1.99-1.32 4.63-.89 6.68-.06z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e95c60",
    d: "M45.37 48.08c-1.83 2.09-4.51 2.75-5.99 1.46-1.47-1.29-1.18-4.03.65-6.13 1.83-2.09 4.51-2.75 5.99-1.46 1.47 1.29 1.18 4.03-.65 6.13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ac8ae",
    d: "M50.66 39.29c-.33-6.18-3.95-5.76-7.4-6.77 1.19 3.2 1.56 7.78 7.4 6.77z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#54af97",
    d: "M50.66 39.29c-3.53.62-5.06-.82-5.98-2.76.94 1.74 2.5 2.95 5.79 2.38-.08-1.41-.32-2.48-.7-3.3.48.87.8 2.04.89 3.68z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#54af97",
    d: "M46.05 34.77c1.77.82 3.36 2.39 4.42 4.38-1.11-1.23-2.65-3.14-4.42-4.38z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f27079",
    d: "M43.84 45.2c-1.04.71-2.29.7-2.79-.03s-.07-1.9.97-2.62c1.04-.71 2.29-.7 2.79.03s.06 1.91-.97 2.62z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ac8ae",
    d: "M49.67 41.62c.18-1.39.48-2.79 1.04-4.12.55-1.33 1.37-2.58 2.46-3.6a.6.6 0 1 1 .82.88l-.04.04c-1.03.8-1.88 1.84-2.51 3.03-.63 1.19-1.06 2.5-1.36 3.84-.02.11-.13.18-.25.16a.215.215 0 0 1-.16-.23z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c1b39",
    d: "M47.04 40.78c1.3 1.7 4.61 1.62 5.6 0-1.91 1.08-3.82.94-5.6 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietChart);
export default __webpack_public_path__ + "static/media/dietChart.8a786ffb248e7b718cab3b58dfb26613.svg";
export { ForwardRef as ReactComponent };